import { ModuleWithProviders, NgModule } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NSession } from './df-session.config';

@NgModule()
export class DfSessionModule {
    static forRoot(config?: DeepPartial<NSession.IModuleOptions>): ModuleWithProviders<DfSessionModule> {
        return {
            ngModule: DfSessionModule,
            providers: [
                {
                    provide: NSession.OPTIONS,
                    useFactory: () => defaultsDeep(config, NSession.DEFAULT_OPTIONS)
                }
            ]
        };
    }
}
